import { NumberField, TextField, SelectField, Form } from '@calendly/form';
import { Banner } from '@calendly/ui/components/banner';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const panelBodyCss = "p1c1rfow";
export const PanelBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(panelBodyCss, props.className)} />;
});
const styledFormIsMobileCss = "smyxpo1";
const styledFormCss = "s1jyapxv";
export const StyledForm = forwardRef((props, ref) => {
  const {
    isMobile
  } = props;
  return <Form ref={ref} {...props} className={classNames(styledFormCss, {
    [styledFormIsMobileCss]: isMobile
  }, props.className)} />;
});
const formContainerCss = "fglegy7";
export const FormContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formContainerCss, props.className)} />;
});
const fieldGroupCss = "f1fnhv5t";
export const FieldGroup = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldGroupCss, props.className)} />;
});
const descriptionCss = "dqvfixg";
export const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const typeToggleContainerCss = "te1raqt";
export const TypeToggleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(typeToggleContainerCss, props.className)} />;
});
const typeButtonSelectedCss = "t1flar7d";
const typeButtonCss = "tvbdjlt";
export const TypeButton = forwardRef((props, ref) => {
  const {
    selected,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(typeButtonCss, {
    [typeButtonSelectedCss]: selected
  }, props.className)} />;
});
const amountContainerCss = "a178pc36";
export const AmountContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(amountContainerCss, props.className)} />;
});
const amountInputContainerCss = "a3kwzhs";
export const AmountInputContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(amountInputContainerCss, props.className)} />;
});
const amountInputFixedCss = "ainn1k8";
const amountInputCss = "a1evokls";
export const AmountInput = forwardRef((props, ref) => {
  const {
    fixed
  } = props;
  return <TextField ref={ref} {...props} className={classNames(amountInputCss, {
    [amountInputFixedCss]: fixed
  }, props.className)} />;
});
const percentSymbolCss = "p1xgc7a1";
export const PercentSymbol = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(percentSymbolCss, props.className)} />;
});
const currencyDisplayCss = "c1nzx20p";
export const CurrencyDisplay = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(currencyDisplayCss, props.className)} />;
});
const currencySymbolCss = "cbd4396";
export const CurrencySymbol = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(currencySymbolCss, props.className)} />;
});
const currencyCodeCss = "c127jr6k";
export const CurrencyCode = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(currencyCodeCss, props.className)} />;
});
const usageLimitContainerCss = "u1o2akxp";
export const UsageLimitContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(usageLimitContainerCss, props.className)} />;
});
const usageLimitInputCss = "uzv920p";
export const UsageLimitInput = forwardRef((props, ref) => <NumberField ref={ref} {...props} className={classNames(usageLimitInputCss, props.className)} />);
const usageLimitTextCss = "u1o7yu17";
export const UsageLimitText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(usageLimitTextCss, props.className)} />;
});
const styledCodeFieldCss = "s1wy5lnn";
export const StyledCodeField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledCodeFieldCss, props.className)} />);
const expirationDateContainerCss = "e1s4mlot";
export const ExpirationDateContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expirationDateContainerCss, props.className)} />;
});
const timeClockCircleIconContainerCss = "twtctm4";
export const TimeClockCircleIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeClockCircleIconContainerCss, props.className)} />;
});
const expirationDateButtonCss = "ekg8df1";
export const ExpirationDateButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(expirationDateButtonCss, props.className)} />);
const selectedDateTextCss = "s2uzlmw";
export const SelectedDateText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(selectedDateTextCss, props.className)} />;
});
const datePickerOverlayIsMobileCss = "dsfn3ej";
const datePickerOverlayCss = "d1uz0vxe";
export const DatePickerOverlay = forwardRef((props, ref) => {
  const {
    isMobile,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(datePickerOverlayCss, {
    [datePickerOverlayIsMobileCss]: isMobile
  }, props.className)} />;
});
const timeSelectContainerCss = "t1rrxlcf";
export const TimeSelectContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeSelectContainerCss, props.className)} />;
});
const styledBannerCss = "shfaiou";
export const StyledBanner = forwardRef((props, ref) => <Banner ref={ref} {...props} className={classNames(styledBannerCss, props.className)} />);
const timeSelectFieldCss = "tcnntt3";
export const TimeSelectField = forwardRef((props, ref) => <SelectField ref={ref} {...props} className={classNames(timeSelectFieldCss, props.className)} />);
const optionsSectionCss = "o18mbr9w";
export const OptionsSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionsSectionCss, props.className)} />;
});
const footerIsMobileCss = "f1ffnu6y";
const footerCss = "f1izdt82";
export const Footer = forwardRef((props, ref) => {
  const {
    isMobile,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsMobileCss]: isMobile
  }, props.className)} />;
});

require("./create_coupon_modal_styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./create_coupon_modal_styles.js");